import z from 'zod';
import { defineDocument } from 'sanity-typed-queries';
import taxonomy from './taxonomy.js';
import pubmedArticleListing from '../objects/pubmedArticleListing.js';
import requiredImage from '../fragments/requiredImage.js';
import arrayEntry from '../fragments/arrayEntry.js';
import internationalizedArrayString from '../fragments/internationalizedArrayString.js';
import internationalizedArraySimpleBlockContent from '../fragments/internationalizedArraySimpleBlockContent.js';
var schema = defineDocument('profile', {
    name: {
        title: 'Name',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    firstName: {
        title: 'Firstname',
        type: 'string'
    },
    image: {
        title: 'Image',
        type: 'image',
        options: requiredImage.fragment.options
    },
    subtitle: {
        title: 'Subtitle',
        type: 'internationalizedArrayString'
    },
    introduction: {
        title: 'Introduction',
        type: 'internationalizedArraySimpleBlockContent'
    },
    email: {
        title: 'Email',
        type: 'string'
    },
    phone: {
        title: 'Phone',
        type: 'string'
    },
    address: {
        title: 'Address',
        type: 'text'
    },
    pubmedQuery: {
        title: 'Pubmed Query',
        type: 'string',
        description: 'Query used to link for PubMed articles'
    },
    pubmedArticles: {
        title: 'Pubmed Articles',
        type: 'array',
        of: [
            {
                type: 'pubmedArticleListing'
            }
        ]
    },
    website: {
        title: 'Website',
        type: 'url'
    },
    socials: {
        title: 'Socials',
        type: 'array',
        of: [
            {
                type: 'string',
                validation: function validation(Rule) {
                    return Rule.regex(/^https?:\/\/(facebook|twitter|linkedin|x|instagram)(\.[a-z]{2,5})+/);
                }
            }
        ]
    },
    hideFromListing: {
        type: 'boolean',
        title: 'Hide from listing'
    }
}, [
    taxonomy.schema.taxonomy,
    pubmedArticleListing.schema.pubmedArticleListing,
    {},
    {}
]);
var validator = z.object({
    name: z.string(),
    firstName: z.string(),
    image: requiredImage.validator,
    subtitle: internationalizedArrayString.validator,
    introduction: internationalizedArraySimpleBlockContent.validator,
    pubmedQuery: z.string(),
    pubmedArticles: z.array(pubmedArticleListing.validator.merge(arrayEntry.validator)),
    socials: z.array(z.string()),
    hideFromListing: z.boolean()
}).partial();
schema.profile;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=profile.js.map